import type { LoginProfileResponse, LoginScopeResponse } from "@medplum/core";
import { isNonEmptyString } from "@/lib/auth/string-guards";

/**
 * Determines whether a login response contains an auth code.
 */
export function isLoginScopeResponse(
  response: LoginProfileResponse | LoginScopeResponse,
): response is LoginScopeResponse {
  return "code" in response && isNonEmptyString(response.code);
}

/**
 * Determines whether a login response contains scope details.
 */
export function isLoginProfileResponse(
  response: LoginProfileResponse | LoginScopeResponse,
): response is LoginProfileResponse {
  return "scope" in response && isNonEmptyString(response.scope);
}

/**
 * OAuth scope every web login requests. `offline_access` makes Medplum issue a refresh token
 * with the access token. Without it the browser holds an access token only, the SDK's own
 * refresh never runs, and the first request after the token's natural expiry is a 401 that ends
 * the session (ENG-5406: a live scribe recording torn down mid-visit).
 */
export const MEDPLUM_LOGIN_SCOPE = "offline_access";
